const BusEnum = Object.freeze({

    KEEP_ALIVE: "KEEP_ALIVE",
    CHAT: "CHAT",
    BROADCAST: "BROADCAST",
    SUCCESS: "SUCCESS",
    INFO: "INFO",
    WARNING: "WARNING",
    ERROR: "ERROR",

    NOTIFICATION_NEW: "NOTIFICATION_NEW",

    AUTH_UPDATE : "AUTH_UPDATE",

    UPDATE_SYSTEM_DETAILS: "UPDATE_SYSTEM_DETAILS",
    UPDATE_GARDEN_DETAILS: "UPDATE_GARDEN_DETAILS",
    UPDATE_DIAGNOSTIC_DETAILS: "UPDATE_DIAGNOSTIC_DETAILS",

    UPDATE_PLANT_DETAILS: "UPDATE_PLANT_DETAILS",
    UPDATE_OIL_DETAILS: "UPDATE_OIL_DETAILS",
    UPDATE_VEGETABLE_DETAILS: "UPDATE_VEGETABLE_DETAILS",
    UPDATE_BOURGEON_DETAILS: "UPDATE_BOURGEON_DETAILS",
    UPDATE_HYDROLAT_DETAILS: "UPDATE_HYDROLAT_DETAILS",
    UPDATE_ADDITIONAL_DETAILS: "UPDATE_ADDITIONAL_DETAILS",

    UPDATE_PHYTO_DETAILS: "UPDATE_PHYTO_DETAILS",
    UPDATE_AROMA_DETAILS: "UPDATE_AROMA_DETAILS",
    UPDATE_HUILO_DETAILS: "UPDATE_HUILO_DETAILS",
    UPDATE_GEMMO_DETAILS: "UPDATE_GEMMO_DETAILS",
    UPDATE_MIX_DETAILS: "UPDATE_MIX_DETAILS",


    USER_UPDATE_GEO : "USER_UPDATE_GEO",

    FRONTEND_UPDATE : "FRONTEND_UPDATE",

    PLAYER_PLAY : "PLAYER_PLAY"
});

export default BusEnum;
